import * as React from 'react';
import { Box, Typography } from '@mui/material';

export default function FederFooter() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        py: 2,
        px: 2,
        width: '100%',
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      {/* FEDER Logo */}
      <Box
        component="img"
        src="/feder-logo.png"
        alt="Fondo Europeo de Desarrollo Regional"
        sx={{
          height: { xs: 50, md: 70 },
          width: 'auto',
          maxWidth: '100%',
          objectFit: 'contain',
        }}
      />

      {/* Legal Text */}
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{
          textAlign: 'center',
          maxWidth: 900,
          lineHeight: 1.5,
        }}
      >
        Yokamotril S.L. ha sido beneficiaria del Fondo Europeo de Desarrollo Regional cuyo objetivo es
        la mejora de la competitividad de las PYMES, y gracias al cual ha puesto en marcha un Plan de
        Acción con el objetivo de reforzar la digitalización y la competitividad de las pymes durante el
        año 2025. Para ello ha contado con el apoyo del Programa Pyme Digital de la Cámara de
        Comercio de Motril. #EuropaSeSiente
      </Typography>
    </Box>
  );
}
